import { saveLeads } from "./saveLeads"

export const finishOrder = async (uid) => {
  const data = {
    aceito: true
  }

  const response = await saveLeads(uid, data)
  return response
}